<template>
    <div :class="['card', {'card_slider': isSlider}]">
        <div class="card__top">
            <div class="card__new" v-if="property.is_promotional">
                new
            </div>
            <favorite-button :id="property.id" :is-catalog="true" :is-complex="false"></favorite-button>
        </div>
        <a :href="url" class="card__img">
            <div class="card__slider swiper">
                <div class="card__wrapper swiper-wrapper" v-if="areImagesArray(property.images)">
                    <div class="card__slide swiper-slide"
                         v-for="(image, index) in property.images.slice(0, 5)"
                         :key="index"
                    >
                        <picture>
                            <source
                                :data-srcset="listThumb(image) + ' 1x, ' + detailsThumb(image) + ' 2x'"
                                media="(min-width: 960px)"
                                :class="index === 0 ? 'lazy' : 'lazy-slider'">
                            <source
                                :data-srcset="detailsThumb(image) + ' 1x, ' + detailsFull(image) + ' 2x'"
                                media="(min-width: 846px) and (max-width: 959px)"
                                :class="index === 0 ? 'lazy' : 'lazy-slider'">
                            <source
                                :data-srcset="listThumb(image) + ' 1x, ' + detailsThumb(image) + ' 2x'"
                                media="(min-width: 641px) and (max-width: 845px)"
                                :class="index === 0 ? 'lazy' : 'lazy-slider'">
                            <source
                                :data-srcset="detailsThumb(image) + ' 1x, ' + detailsFull(image) + ' 2x'"
                                media="(min-width: 426px) and (max-width: 640px)"
                                :class="index === 0 ? 'lazy' : 'lazy-slider'">
                            <source
                                :data-srcset="listThumb(image) + ' 1x, ' + detailsThumb(image) + ' 2x'"
                                media="(max-width: 425px)"
                                :class="index === 0 ? 'lazy' : 'lazy-slider'">
                            <img
                                :data-src="listThumb(image)"
                                :class="index === 0 ? 'lazy' : 'lazy-slider'"
                                :alt="image['custom_properties']['alt']">
                        </picture>
                    </div>
                </div>
                <div v-else class="card__wrapper swiper-wrapper">
                    <div class="card__slide swiper-slide">
                        <img src="/img/noimage/no-image.svg" alt="">
                    </div>
                </div>
                <div class="card-button card-button_prev _icon-slider_arr-left"></div>
                <div class="card-button card-button_next _icon-slider_arr-right"></div>
                <div class="swiper-pagination swiper-pagination_card"></div>
            </div>
        </a>
        <div class="card__info info-card">
            <div class="info-card__top top-card-info">
                <div class="top-card-info__loc" v-if="property.district">
                    {{ property.district.title }}
                </div>
                <a :href="url" class="top-card-info__title">
                    {{ property.title }}
                </a>
                <div class="top-card-info__subtitle">
                    <p v-html="property.cleanedUpOverview"></p>
                </div>
                <div class="top-card-info__price">
                    <span v-if="property.price">{{ formatPrice(property.price) }}{{ trans('currencies.'+currency) }}</span>
                    <span class="info__price__on-request" v-if="!property.price">
                        Цена по запросу
                    </span>
                </div>
            </div>
            <div class="info-card__bottom bottom-card-info">
                <div class="bottom-card-info__row">
                    <div class="bottom-card-info__item item-bottom-info-card">
                        <div class="item-bottom-info-card__title">{{ 'Bedrooms' | trans }}</div>
                        <div class="item-bottom-info-card__wrapper">
                            <div class="item-bottom-info-card__icon _icon-card_bedroom"></div>
                            <div class="item-bottom-info-card__quantity">{{ property.bedrooms_number }}</div>
                        </div>
                    </div>
                    <div class="bottom-card-info__item item-bottom-info-card">
                        <div class="item-bottom-info-card__title">{{ 'Bathrooms' | trans }}</div>
                        <div class="item-bottom-info-card__wrapper">
                            <div class="item-bottom-info-card__icon _icon-card_bathroom"></div>
                            <div class="item-bottom-info-card__quantity">{{ property.bathrooms_number }}</div>
                        </div>
                    </div>
                    <div class="bottom-card-info__item item-bottom-info-card">
                        <div class="item-bottom-info-card__title">{{ 'Floor' | trans }}</div>
                        <div class="item-bottom-info-card__wrapper">
                            <div class="item-bottom-info-card__icon _icon-card_floor"></div>
                            <div class="item-bottom-info-card__quantity">{{ property.apartment_floor_number }}</div>
                        </div>
                    </div>
                    <div class="bottom-card-info__item item-bottom-info-card">
                        <div class="item-bottom-info-card__title">{{ 'Area' | trans }} <span>{{ trans('units.' + property.converted_building_area_symbol) }}</span></div>
                        <div class="item-bottom-info-card__wrapper">
                            <div class="item-bottom-info-card__icon _icon-card_square"></div>
                            <div class="item-bottom-info-card__quantity">{{ property.converted_building_area }} <span>{{ trans('units.' + property.converted_building_area_symbol) }}</span></div>
                        </div>
                    </div>
                </div>
                <div class="bottom-card-info__actions">
                    <a  :href="`https://wa.me/${messengerPhone}?text=${transParam(trans('whatsapp.property_message'),{ 'url': encodeURIComponent(url)})}`" class="bottom-card-info__link" target="_blank" rel="noopener noreferrer">
                        <img src="/img/whatsapp.svg" alt="">
                        Whatsapp
                    </a>
                    <a :href="'tel:'+contactPhone" class="bottom-card-info__link" rel="noopener noreferrer">
                        <img src="/img/tel.svg" alt="">
                        Call
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {addLoadListenerToLazyLoadObjects, initSliders} from "../../shareable/functions"

import transParam from "../../../helpers/trans";

export default {
    name: "CatalogPropertyCard",
    data(){
       return {
           transParam:transParam
       }
    },
    props: {
        property: {
            type: Object,
            default: null
        },
        isSlider: {
            type: Boolean,
            default: false,
        }
    },
    computed:{
        url(){
            const baseUrl = this.$root.baseUrl || '';

            const typeSlug = this.property?.propertyType?.slug || '';
            const propertySlug = this.property?.slug || '';

            const safeTypeSlug = encodeURIComponent(typeSlug);
            const safePropertySlug = encodeURIComponent(propertySlug);

            return `${baseUrl}/properties-for-sale/${safeTypeSlug}/${safePropertySlug}`;
        },
        currency() {
            return window.currentCurrency;
        },
        messengerPhone() {
            return window.messengerPhone;
        },
        contactPhone() {
            return window.contactPhone;
        }
    },
    methods: {
        formatPrice(price) {
            return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        },
        areImagesArray(images) {
            return Array.isArray(images) && images.length > 0
        },
        listThumb(image) {
            return '/storage/' + image.id + '/conversions/' + image.name.replaceAll(' ', '-') + '-list_thumb_webp.webp';
        },
        detailsThumb(image) {
            return '/storage/' + image.id + '/conversions/' + image.name.replaceAll(' ', '-') + '-details_thumb_webp.webp';
        },
        detailsFull(image) {
            return '/storage/' + image.id + '/conversions/' + image.name.replaceAll(' ', '-') + '-details_full_webp.webp';
        }
    },
    mounted() {
        initSliders();
        addLoadListenerToLazyLoadObjects();
    }
}

</script>

<style scoped>
.card {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.card.card_slider {
    height: auto !important;
}

.card.card_slider img {
    height: 100% !important;
}
</style>
